import { useI18n } from "@core/i18n/i18n";
import { Gender } from "@domain/patient/gender";
import { useCallback } from "react";

type UseFormatGenderHook = (gender: Gender) => string;

export const useFormatGender = (): UseFormatGenderHook => {
	const { format } = useI18n();

	return useCallback(
		(gender: Gender) => {
			switch (gender) {
				case Gender.Man:
					return format("global.gender.man");
				case Gender.Woman:
					return format("global.gender.woman");
				case Gender.Other:
					return format("global.gender.other");
				default:
					return "";
			}
		},
		[format],
	);
};
